import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem("authToken") || null, // Retrieve token from localStorage if available
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken(state, action) {
      state.token = action.payload;
      localStorage.setItem("authToken", action.payload); // Save token to localStorage
    },
    clearToken(state) {
      state.token = null;
      localStorage.removeItem("authToken"); // Remove token from localStorage
    },
  },
});

export const { setToken, clearToken } = authSlice.actions;

export default authSlice.reducer;
